module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ProductEvaluateView.js"));
	}, "ProductEvaluate");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductEvaluate!./src/pages/Shop/Product/ProductDetail/ProductEvaluate/ProductEvaluateView.js
// module id = 876
// module chunks = 431